import BoostAPI from '../api/boostAPI';
import { IApiResponse } from '../interfaces/IApiResponse';
import { IConsumable, IConsumableExpiry } from '../interfaces/IConsumable';
import Consumable, { IInviteCredit } from '../models/consumable';
import { IBoostMySelf } from 'redhotpie-shared-lib/types/boost';

class BoostService {
  getUserRemainingInvitesCredit(): Promise<IApiResponse<IInviteCredit>> {
    return BoostAPI.getUserRemainingInvitesCredit().then((res: IApiResponse) => {
      let apiResponse: IApiResponse<IInviteCredit> = {
        success: false,
        data: {
          remainingLimit: 0,
          dailyLimit: 0,
          remainingCredits: 0,
        },
        message: '',
      };
      try {
        if (res.success) {
          apiResponse.success = true;
          apiResponse.data = Consumable.mappingUserRemainingInvitesCredit(res.data);
        } else {
          console.log('ERROR: BoostService/getUserRemainingInvitesCredit:', res.message);
          apiResponse.message = res.message;
        }
      } catch (e) {
        console.log('ERROR: BoostService/getUserRemainingInvitesCredit:', e);
        apiResponse.message = 'ERROR: BoostService/getUserRemainingInvitesCredit';
      }
      return apiResponse;
    });
  }

  getListInvitesCreditProducts(): Promise<IApiResponse> {
    return BoostAPI.getListInvitesCreditProducts().then((res: IApiResponse) => {
      let apiResponse: IApiResponse<IConsumable[]> = {
        success: false,
        data: [],
        message: '',
      };
      try {
        if (res.success) {
          apiResponse.success = true;
          apiResponse.data = Consumable.mappingConsumableProducts(res.data?.items);
        } else {
          console.log('ERROR: BoostService/getListInvitesCreditProducts:', res.message);
          apiResponse.message = res.message;
        }
      } catch (e) {
        console.log('ERROR: BoostService/getListInvitesCreditProducts:', e);
        apiResponse.message = 'ERROR: BoostService/getListInvitesCreditProducts';
      }
      return apiResponse;
    });
  }

  getListProfileBoostProduct(): Promise<IApiResponse> {
    return BoostAPI.getListProfileBoostProducts().then((res: IApiResponse) => {
      let apiResponse: IApiResponse<IConsumable[]> = {
        success: false,
        data: [],
        message: '',
      };
      try {
        if (res.success) {
          apiResponse.success = true;
          apiResponse.data = Consumable.mappingConsumableProducts(res.data?.items);
        } else {
          console.log('ERROR: BoostService/getListProfileBoostProduct:', res.message);
          apiResponse.message = res.message;
        }
      } catch (e) {
        console.log('ERROR: BoostService/getListProfileBoostProduct:', e);
        apiResponse.message = 'ERROR: BoostService/getListProfileBoostProduct';
      }
      return apiResponse;
    });
  }

  getListConversationBoostProduct(): Promise<IApiResponse> {
    return BoostAPI.getListConversationBoostProducts().then((res: IApiResponse) => {
      let apiResponse: IApiResponse<IConsumable[]> = {
        success: false,
        data: [],
        message: '',
      };
      try {
        if (res.success) {
          apiResponse.success = true;
          apiResponse.data = Consumable.mappingConsumableProducts(res.data?.items);
        } else {
          console.log('ERROR: BoostService/getListConversationBoostProduct:', res.message);
          apiResponse.message = res.message;
        }
      } catch (e) {
        console.log('ERROR: BoostService/getListConversationBoostProduct:', e);
        apiResponse.message = 'ERROR: BoostService/getListConversationBoostProduct';
      }
      return apiResponse;
    });
  }

  getGenderTypeChangeProduct(): Promise<IApiResponse> {
    return BoostAPI.getGenderChangeProduct().then((res: IApiResponse) => {
      let apiResponse: IApiResponse<IConsumable[]> = {
        success: false,
        data: [],
        message: '',
      };
      try {
        if (res.success) {
          apiResponse.success = true;
          apiResponse.data = Consumable.mappingConsumableProducts(res.data?.items || []);
        } else {
          console.log('ERROR: BoostService/getGenderTypeChangeProduct:', res.message);
          apiResponse.message = res.message;
        }
      } catch (e) {
        console.log('ERROR: BoostService/getGenderTypeChangeProduct:', e);
        apiResponse.message = 'ERROR: BoostService/getGenderTypeChangeProduct';
      }
      return apiResponse;
    });
  }

  purchaseConsumableProduct(consumablePriceID: string, metaData?: any): Promise<IApiResponse<IConsumableExpiry>> {
    return BoostAPI.purchaseConsumableProduct(consumablePriceID, metaData).then((res: IApiResponse<IConsumableExpiry>) => {
      let apiResponse: IApiResponse<IConsumableExpiry> = {
        success: false,
        data: undefined,
        message: '',
      };
      try {
        if (res.success) {
          apiResponse.success = true;
          apiResponse.data = Consumable.mappingConsumablePurchaseResponse(res.data);
        } else {
          console.log('ERROR: BoostService/purchaseConsumableProduct:', res.message);
          apiResponse.message = res.message;
        }
      } catch (e) {
        console.log('ERROR: BoostService/purchaseConsumableProduct:', e);
        apiResponse.message = 'ERROR: BoostService/purchaseConsumableProduct';
      }
      return apiResponse;
    });
  }

  notifyBoostMySelf(data: IBoostMySelf): Promise<IApiResponse> {
    return BoostAPI.notifyBoostMySelf(data).then((res: IApiResponse) => {
      let apiResponse: IApiResponse = {
        success: false,
        data: undefined,
        message: '',
      };
      try {
        if (res.success) {
          apiResponse.success = true;
        } else {
          console.log('ERROR: BoostService/notifyBoostMySelf:', res.message);
          apiResponse.message = res.message;
        }
      } catch (e) {
        console.log('ERROR: BoostService/notifyBoostMySelf:', e);
        apiResponse.message = 'ERROR: BoostService/notifyBoostMySelf';
      }
      return apiResponse;
    });
  }

  getLikeProducts(): Promise<IApiResponse> {
    return BoostAPI.getLikeProducts().then((res: IApiResponse) => {
      let apiResponse: IApiResponse<IConsumable[]> = {
        success: false,
        data: [],
        message: '',
      };
      try {
        if (res.success) {
          apiResponse.success = true;
          apiResponse.data = Consumable.mappingConsumableProducts(res.data?.items || []);
        } else {
          console.log('ERROR: BoostService/getLikeProducts:', res.message);
          apiResponse.message = res.message;
        }
      } catch (e) {
        console.log('ERROR: BoostService/getLikeProducts:', e);
        apiResponse.message = 'ERROR: BoostService/getLikeProducts';
      }
      return apiResponse;
    });
  }

  getFavProducts(): Promise<IApiResponse> {
    return BoostAPI.getFavProducts().then((res: IApiResponse) => {
      let apiResponse: IApiResponse<IConsumable[]> = {
        success: false,
        data: [],
        message: '',
      };
      try {
        if (res.success) {
          apiResponse.success = true;
          apiResponse.data = Consumable.mappingConsumableProducts(res.data?.items || []);
        } else {
          console.log('ERROR: BoostService/getFavProducts:', res.message);
          apiResponse.message = res.message;
        }
      } catch (e) {
        console.log('ERROR: BoostService/getFavProducts:', e);
        apiResponse.message = 'ERROR: BoostService/getFavProducts';
      }
      return apiResponse;
    });
  }
}

export default new BoostService();
